import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCrossRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g><path fill="currentColor" fillRule="evenodd" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m5.76 20.28c.4.4.4 1.06 0 1.46a1.015 1.015 0 0 1-1.44 0l-4.3-4.3-4.32 4.3a1.015 1.015 0 0 1-1.44 0c-.4-.4-.4-1.06 0-1.46l4.3-4.28-4.3-4.28c-.4-.38-.4-1.04 0-1.44s1.04-.4 1.44 0l4.32 4.28 4.3-4.28c.4-.4 1.04-.4 1.44 0s.4 1.06 0 1.44L17.46 16z" clipRule="evenodd" /></g></svg>;
export default SvgIconCrossRoundedFilled;